export default __webpack_public_path__ + "static/media/destinos.0316493a.jpg";